import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import api from "@/lib/api";

/* Sends one beacon per route change with the path the user is on,
 * the referrer (only on the FIRST page of the session so we don't
 * over-attribute internal nav), the page title, viewport size and
 * browser language. Backend uses these to power the analytics
 * dashboard — no PII is sent. */
let sentReferrer = false;

export default function VisitTracker() {
  const location = useLocation();
  useEffect(() => {
    if (location.pathname.startsWith("/admin")) return;
    const ref = sentReferrer ? null : document.referrer || null;
    sentReferrer = true;
    api
      .post("/track-visit", {
        path: (location.pathname + location.search).slice(0, 300),
        referrer: ref,
        title: (document.title || "").slice(0, 200),
        screen: `${window.innerWidth}x${window.innerHeight}`.slice(0, 20),
        lang: (navigator.language || "").slice(0, 35) || null,
      })
      .catch(() => {
        /* offline / blocked — analytics are not critical */
      });
  }, [location.pathname, location.search]);
  return null;
}
